module.exports = __webpack_public_path__ + "static/media/call-allow-pop.c3e4cc76.png";